import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'mom-survey-footer',
  templateUrl: './survey-footer.component.html',
  styleUrls: ['./survey-footer.component.scss']
})
export class SurveyFooterComponent {
  @Input() disableNextButton: boolean;
  @Input() isProcessing: boolean;
  @Input() waitingPhoneVerification: boolean;
  @Input() label = 'Next';
  @Input() points: string;
  @Input() showPointsInd = true;
  @Input() showIconInd = true;
  @Input() usePrevButtonInd = true;

  @Output() emitNext = new EventEmitter<void>();
  @Output() emitPrev = new EventEmitter<void>();

  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
}
